module.exports = __webpack_public_path__ + "img/logo-placeholder.9b55a5bc.jpg";